import { useContext, useEffect, useState } from 'react';
import { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';

import './ImageField.scss';

const PreviewImageField = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    let fieldDataSchema = getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.featureData._id, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null);
    let valPathToUse = fieldData?.customFieldConfig?.dataLink;
    if (fieldDataSchema?.previewFor) {
        const pathSplit = fieldData?.customFieldConfig?.dataLink?.split('.') || [];
        pathSplit.pop();
        const previewFor = fieldDataSchema.previewFor;
        pathSplit.push(previewFor);
        valPathToUse = pathSplit.join('.');
        const previewFieldData = getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.featureData._id, valPathToUse, props.index ?? 0, props.visualisationComponentKey ?? null);
        fieldDataSchema = previewFieldData;
    }
    const val = getCustomisationValue(customisationVars, valPathToUse, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
    const matchingOption = fieldDataSchema?.valOptions?.find(opt => opt.value === val);
    const imgSrc = matchingOption?.previewFile;
    console.log("PreviewImageField props:", props, fieldData, fieldDataSchema, val, matchingOption, imgSrc);

    /* const [imageFileData, setImageFileData] = useState(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    useEffect(() => {
        setImageFileData(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode]); */

    /* const clickHandler = () => {
        props.openTemporaryImageUploadPopup(
            imageFileData,
            (groupConfig?.parent?.name ? groupConfig?.parent?.name + ' > ' : '') + (groupConfig?.name ? groupConfig?.name + ' > ' : '') + moduleConfig.name,
            'This is a temporary image uploader and is not final.',
        )
    } */

    const [imageDimensions, setImageDimensions] = useState({width: 'unknown', height: 'unknown'});
    useEffect(() => {
        setImageDimensions({width: 'unknown', height: 'unknown'});
        if (imgSrc) {
            const img = new Image();
            img.onload = () => {
                setImageDimensions({width: img.width, height: img.height});
            }
            img.src = '/customise-previews/' + imgSrc;
        }
    }, [imgSrc]);

    return (
        <>
            {/* <p>Preview Image</p> */}
            {/* <div className='v2-module-field-label'>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Image'}</div>
            <ModuleTextInput
                fieldLabel={<div className="v2-module-block-field-input-label" style={{backgroundColor: '#FFFFFF', backgroundImage: `url(${ImageIcon})`, backgroundSize: '1.8rem', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}} />}
                value={typeof imageFileData === 'string' ? imageFileData : imageFileData?.originalFile ?? '<No Image>'}
                fieldId={'image-file'}
                enabled={props.isEnabled}
                editable={false}
                onChange={null}
                onClick={
                    props.isEnabled ? clickHandler : null
                }
            /> */}
            {imgSrc &&
                <div className={`image-preview-holder preview${!props.isEnabled ? ' v2-module-disabled-field' : ''}`}>
                    <img src={'/customise-previews/' + imgSrc} alt={matchingOption.label} />
                    {imageDimensions.width !== 'unknown' &&
                        <div className="image-dimensions-label">{imageDimensions.width} x {imageDimensions.height}</div>
                    }
                    {imageDimensions.width === 'unknown' &&
                        <div className="image-dimensions-label">&nbsp;</div>
                    }
                </div>
            }
        </>
    );
};

export default PreviewImageField;
